import React from "react";
import { Button, Dialog, DialogTitle, DialogActions, DialogContentText, DialogContent } from "@mui/material";
import { PropTypes } from "prop-types";
import Typography from "@mui/material/Typography";

AlertDialog.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};
export default function AlertDialog(props) {
  let { title, text, isOpen, onClose } = props;
  return (
    <div>
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>
          <Typography variant="h3" color="primary">
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button size="medium" color="primary" variant="text" onClick={onClose}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
